var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviHomeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 26.5h25v-25h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.52 12.535-8.35-7.931a1.701 1.701 0 0 0-2.341 0l-8.35 7.931c-.335.32-.528.77-.528 1.233v8.395c0 .938.763 1.7 1.7 1.7h5.55a.723.723 0 0 0 .724-.722v-2.639c0-1.174.88-2.175 1.962-2.232a2.077 2.077 0 0 1 2.189 2.073v2.798c0 .399.323.722.722.722h5.55c.938 0 1.7-.762 1.7-1.7v-8.395c0-.463-.192-.913-.528-1.233",
    fill: "#E5E6E8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviHomeActive);
export default __webpack_public_path__ + "static/media/navi-home-active.b455210b8d2a90e4c29e65c69d42695b.svg";
export { ForwardRef as ReactComponent };